export enum ProductTitle {
  KatKinFreshMealPlan = "KatKin Fresh Meal Plan",
  AddOnPlan = "AddOn Plan",
  HealthScoop = "Health Scoop",
  PlanetScoop = "Planet Scoop",
  NibblesChicken = "Nibbles Chicken",
  NibblesSalmon = "Nibbles Salmon",
  Sprinkles = "Sprinkles",
  DPDDeliveryFee = "DPD Delivery Fee",
  Cluck = "Cluck!",
  Gobble = "Gobble!",
  Quack = "Quack!",
  Oink = "Oink!",
  Splash = "Splash!",
  Baaa = "Baaa!",
  Mooo = "Mooo!",
  BubbleAndQuack = "Bubble and Quack!",
  PouchChicken = "Pouch Chicken!",
  PouchTurkey = "Pouch Turkey!",
  PouchBeef = "Pouch Beef!",
  PouchDuck = "Pouch Duck!",
  Cluck2404 = "2404 Cluck!",
  Gobble2404 = "2404 Gobble!",
  Quack2404 = "2404 Quack!",
  Oink2404 = "2404 Oink!",
  Splash2404 = "2404 Splash!",
  Baaa2404 = "2404 Baaa!",
  Mooo2404 = "2404 Mooo!",
}

export type ParentProduct = ProductTitle.KatKinFreshMealPlan | ProductTitle.AddOnPlan;

export type ChildProduct = Exclude<ProductTitle, ParentProduct>;
